var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dspDetectedFilterNames, } from './framework/Config';
export class YamahaAdecia {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        // other class properties and constructor
        this.channels = [];
        // controls
        this.detected = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.channels.map(ch => {
                    var _a;
                    return {
                        channel: ch.key,
                        filters: Object.fromEntries(dspDetectedFilterNames.map(name => [name, this.testFilter(ch, name)])),
                        name: ch.name,
                        type: (_a = ch.key.split('-')[0]) !== null && _a !== void 0 ? _a : 'unknown',
                    };
                });
                return [];
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`devinfo version`, /^OK\s+devinfo\s+version\s+"V(.+)"|ERROR/i, tags);
                if (match[1] === undefined)
                    throw new Error(`failed getting firmware version`);
                return match[1];
            }),
        };
        this.mute = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const muteParam = (_a = this.channels.find(ch => ch.key === key)) === null || _a === void 0 ? void 0 : _a.mute;
                if (muteParam === undefined)
                    return this.state.mutes.values[key];
                const cmd = this.makeParamCommand('get', muteParam);
                const fn = (resp) => this.matchParamResponse(resp, 'OK', 'get', muteParam);
                const match = yield this.socket.send(cmd, fn, tags);
                if (match === '')
                    return this.state.mutes.values[key];
                return muteParam.invert ? match !== '1' : match === '1';
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _b, _c;
                const muteParam = (_b = this.channels.find(ch => ch.key === key)) === null || _b === void 0 ? void 0 : _b.mute;
                if (muteParam === undefined)
                    return this.state.mutes.values[key];
                const valueStr = value === ((_c = muteParam.invert) !== null && _c !== void 0 ? _c : false) ? '0' : '1';
                const cmd = this.makeParamCommand('set', muteParam, valueStr);
                const fn = (cmd) => this.matchParamResponse(cmd, 'OK', 'set', muteParam);
                const match = yield this.socket.send(cmd, fn, tags);
                if (match === '')
                    return this.state.mutes.values[key];
                return muteParam.invert ? match !== '1' : match === '1';
            }),
            getKey: config => config,
            validate: this.validate.bind(this),
            asyncHandlers: {
                match: (cmd) => {
                    const tokens = cmd.split(/\s+/);
                    for (const ch of this.channels) {
                        if (ch.mute === undefined)
                            continue;
                        if (!ch.mute.configured)
                            continue;
                        const match = this.matchParamResponse(tokens, 'NOTIFY', 'set', ch.mute);
                        if (match !== undefined && match !== '') {
                            return {
                                key: ch.key,
                                value: ch.mute.invert ? match !== '1' : match === '1',
                            };
                        }
                    }
                    return undefined;
                },
                callback: (match) => {
                    this.state.mutes.update(match.key, match.value);
                },
            },
        };
        this.serialNumber = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`devinfo serialno`, /^OK\s+devinfo\s+serialno\s+"(.+)"|ERROR/i, tags);
                if (match[1] === undefined)
                    throw new Error(`failed getting serial number`);
                return match[1];
            }),
        };
        this.telephony = {
            answer: (key) => __awaiter(this, void 0, void 0, function* () {
                var _d;
                const telephony = (_d = this.channels.find(ch => ch.key === key)) === null || _d === void 0 ? void 0 : _d.telephony;
                if (telephony === undefined)
                    return false;
                yield this.socket.send(`event rm:callaction "offhook=${telephony.lineName}"`, /.+/);
                return false;
            }),
            call: (value) => __awaiter(this, void 0, void 0, function* () {
                const ch = this.getAvailableTelephonyChannel(value.callType);
                if ((ch === null || ch === void 0 ? void 0 : ch.telephony) === undefined) {
                    this.log.error(`no available ${value.callType} call interfaces`);
                    return undefined;
                }
                const lineName = ch.telephony.lineName;
                yield this.socket.send(`event rm:callaction "dial=${lineName}:${value.dialString}"`, /.+/);
                return ch.key;
            }),
            dial: (key, value) => __awaiter(this, void 0, void 0, function* () {
                var _e;
                const telephony = (_e = this.channels.find(ch => ch.key === key)) === null || _e === void 0 ? void 0 : _e.telephony;
                if (telephony === undefined)
                    return '';
                const lineName = telephony.lineName;
                for (const digit of value) {
                    yield this.socket.send(`event rm:callaction "dtmf=${lineName}:${digit}"`, /.+/);
                }
                return value;
            }),
            hangup: (key) => __awaiter(this, void 0, void 0, function* () {
                var _f;
                const telephony = (_f = this.channels.find(ch => ch.key === key)) === null || _f === void 0 ? void 0 : _f.telephony;
                if (telephony === undefined)
                    return false;
                const lineName = telephony.lineName;
                yield this.socket.send(`event rm:callaction "hangup=${lineName}"`, /.+/);
                return false;
            }),
            receiveGainRange: { max: 1000, min: -1000, round: 5 },
            reject: (key) => __awaiter(this, void 0, void 0, function* () {
                var _g;
                const telephony = (_g = this.channels.find(ch => ch.key === key)) === null || _g === void 0 ? void 0 : _g.telephony;
                if (telephony === undefined)
                    return false;
                const lineName = telephony.lineName;
                yield this.socket.send(`event rm:callaction "hangup=${lineName}"`, /.+/);
                return false;
            }),
            setReceiveGain: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _h;
                const telephony = (_h = this.channels.find(ch => ch.key === key)) === null || _h === void 0 ? void 0 : _h.telephony;
                if (telephony === undefined)
                    return value;
                const gainParam = telephony.receiveGain;
                const cmd = this.makeParamCommand('set', gainParam, value.toString());
                const fn = (cmd) => this.matchParamResponse(cmd, 'OK', 'set', gainParam);
                const match = yield this.socket.send(cmd, fn, tags);
                return match === '' ? value : parseInt(match, 10);
            }),
            getCalls: () => __awaiter(this, void 0, void 0, function* () {
                const calls = {};
                // Initially report calls as disconnected. Polling will update to the correct states.
                for (const ch of this.channels) {
                    if (ch.telephony !== undefined && ch.telephony.configured) {
                        calls[ch.key] = this.state.calls.addMissing({
                            callType: 'voip',
                            canDial: true,
                            receiveGain: 0,
                        });
                        // Send async query and let async handlers update the receive gain.
                        this.socket.sendAsync(this.makeParamCommand('get', ch.telephony.receiveGain));
                    }
                }
                return calls;
            }),
            getMaxCalls: () => __awaiter(this, void 0, void 0, function* () {
                const maxCalls = {};
                for (const ch of this.channels) {
                    if (ch.telephony !== undefined && ch.telephony.configured) {
                        if (maxCalls.voip === undefined)
                            maxCalls.voip = 0;
                        maxCalls.voip++;
                    }
                }
                return maxCalls;
            }),
            getKey: (config) => config,
            validate: this.validate.bind(this),
            asyncHandlers: [
                {
                    match: (cmd) => {
                        const tokens = cmd.split(/\s+/);
                        for (const ch of this.channels) {
                            if (ch.telephony === undefined)
                                continue;
                            if (!ch.telephony.configured)
                                continue;
                            const value = this.matchParamResponse(tokens, 'NOTIFY', 'set', ch.telephony.receiveGain);
                            if (value !== undefined && value !== '') {
                                return { key: ch.key, value: parseInt(value, 10) };
                            }
                        }
                        return undefined;
                    },
                    callback: (match) => {
                        this.state.calls.updateReceiveGain(match.key, match.value);
                        this.state.volumes.update(match.key, match.value);
                    },
                },
                {
                    regExp: /^(?:NOTIFY|OK)\s+event\s+rm:(?:get|changed)callstatus "(.+)"/i,
                    callback: (match) => {
                        var _a;
                        const entries = match[1].split(',').map(v => v.split('='));
                        for (const ch of this.channels) {
                            if (ch.telephony === undefined || !ch.telephony.configured)
                                continue;
                            if (this.state.calls.values[ch.key] === undefined)
                                continue;
                            for (const [prop, value] of entries) {
                                if (prop === ch.telephony.lineName) {
                                    switch (value) {
                                        case 'active':
                                        case 'active/mute':
                                        case 'inconference_active':
                                        case 'inconference_active/mute':
                                        case 'inconference_music':
                                        case 'inconference_music/mute':
                                        case 'inconference_onhold':
                                        case 'inconference_onhold/mute':
                                        case 'music':
                                        case 'music/mute':
                                        case 'onhold':
                                        case 'onhold/mute':
                                            this.state.calls.connect(ch.key);
                                            break;
                                        case 'calling':
                                        case 'calling/mute':
                                        case 'inconference_calling':
                                        case 'inconference_calling/mute':
                                            this.state.calls.setOutgoing(ch.key);
                                            break;
                                        case 'idle':
                                            this.state.calls.disconnect(ch.key);
                                            break;
                                        case 'incoming':
                                        case 'incoming/mute':
                                        case 'inconference_incoming':
                                        case 'inconference_incoming/mute':
                                            this.state.calls.setIncoming(ch.key);
                                            break;
                                        case 'failed':
                                            // Don't disconnect call on "failed" status. We need to
                                            // leave the call card up so the user can hang up the call.
                                            // See SNTY-2625.
                                            //this.state.calls.disconnect(ch.key);
                                            break;
                                        default:
                                            this.log.error(`unhandled callstatus: ${value}`);
                                            break;
                                    }
                                }
                                else if (prop === `${ch.telephony.lineName}number`) {
                                    if (((_a = this.state.calls.values[ch.key]) === null || _a === void 0 ? void 0 : _a.direction) === 'incoming') {
                                        this.state.calls.updateCall(ch.key, { dialString: value });
                                    }
                                }
                            }
                        }
                    },
                },
            ],
        };
        this.volume = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                var _j;
                const volumeParam = (_j = this.channels.find(ch => ch.key === key)) === null || _j === void 0 ? void 0 : _j.volume;
                if (volumeParam === undefined)
                    return this.state.volumes.values[key];
                const cmd = this.makeParamCommand('get', volumeParam);
                const fn = (cmd) => this.matchParamResponse(cmd, 'OK', 'get', volumeParam);
                const match = yield this.socket.send(cmd, fn, tags);
                return match === '' ? this.state.volumes.values[key] : parseInt(match, 10);
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _k;
                const volumeParam = (_k = this.channels.find(ch => ch.key === key)) === null || _k === void 0 ? void 0 : _k.volume;
                if (volumeParam === undefined)
                    return this.state.volumes.values[key];
                const cmd = this.makeParamCommand('set', volumeParam, value.toString());
                const fn = (cmd) => this.matchParamResponse(cmd, 'OK', 'set', volumeParam);
                const match = yield this.socket.send(cmd, fn, tags);
                return match === '' ? this.state.volumes.values[key] : parseInt(match, 10);
            }),
            getKey: config => config,
            validate: this.validate.bind(this),
            range: (config, info) => __awaiter(this, void 0, void 0, function* () {
                if (info.volumeType === 'trim')
                    return { max: 1000, min: -1400, round: 5 };
                return { max: 1000, min: -4000, round: 5 }; // volume
            }),
            asyncHandlers: {
                match: (cmd) => {
                    const tokens = cmd.split(/\s+/);
                    for (const ch of this.channels) {
                        if (ch.volume === undefined)
                            continue;
                        if (!ch.volume.configured)
                            continue;
                        const value = this.matchParamResponse(tokens, 'NOTIFY', 'set', ch.volume);
                        if (value !== undefined && value !== '') {
                            return { key: ch.key, value: parseInt(value, 10) };
                        }
                    }
                    return undefined;
                },
                callback: (match) => {
                    this.state.volumes.update(match.key, match.value);
                },
            },
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    return this.socket.sendAsync(`event rm:getcallstatus`, ['poll']);
                }),
            },
        ];
        this.channels.push({
            name: `Bluetooth In`,
            key: `bluetoothIn`,
            mute: { address: `RM:FeIn_Fader/Ch/On`, subAddress: [0, 1], invert: true },
            volume: { address: `RM:FeIn_Fader/Ch/Level`, subAddress: [0, 1] },
            filters: { input: true, mics: true, output: true },
        });
        this.channels.push({
            name: `Aux In`,
            key: `auxIn`,
            mute: { address: `RM:FeIn_Fader/Ch/On`, subAddress: [2, 3], invert: true },
            volume: { address: `RM:FeIn_Fader/Ch/Level`, subAddress: [2, 3] },
            filters: { input: true, mics: true, output: true },
        });
        this.channels.push({
            name: `USB In`,
            key: `usbIn`,
            mute: { address: `RM:FeIn_Fader/Ch/On`, subAddress: [6, 7], invert: true },
            volume: { address: `RM:FeIn_Fader/Ch/Level`, subAddress: [6, 7] },
            filters: { input: true, mics: true, output: true },
        });
        this.channels.push({
            name: `Bluetooth Out`,
            key: `bluetoothOut`,
            mute: { address: `RM:FeOut_Fader/Ch/On`, subAddress: [0, 1], invert: true },
            volume: { address: `RM:FeOut_Fader/Ch/Level`, subAddress: [0, 1] },
            filters: { input: true, mics: true, output: true },
        });
        this.channels.push({
            name: `Aux Out`,
            key: `auxOut`,
            mute: { address: `RM:FeOut_Fader/Ch/On`, subAddress: [2, 3], invert: true },
            volume: { address: `RM:FeOut_Fader/Ch/Level`, subAddress: [2, 3] },
            filters: { input: true, mics: true, output: true },
        });
        this.channels.push({
            name: `USB Out`,
            key: `usbOut`,
            mute: { address: `FeOut_Fader/Ch/On`, subAddress: [6, 7], invert: true },
            volume: { address: `FeOut_Fader/Ch/Level`, subAddress: [6, 7] },
            filters: { input: true, mics: true, output: true },
        });
        for (let n = 0; n < 16; n++) {
            this.channels.push({
                name: `Dante In ${n + 1}`,
                key: `danteIn-${n + 1}`,
                mute: { address: `RM:NeIn_Fader/Ch/On`, subAddress: [n], invert: true },
                volume: { address: `RM:NeIn_Fader/Ch/Level`, subAddress: [n] },
                filters: { input: true, mics: true, output: true },
            });
        }
        this.channels.push({
            name: `Analog Speaker Out`,
            key: `analogSpeakerOut`,
            mute: { address: `RM:NeOut_Fader/Ch/On`, subAddress: [0, 1], invert: true },
            volume: { address: `RM:NeOut_Fader/Ch/Level`, subAddress: [0, 1] },
            filters: { input: true, mics: true, output: true },
        });
        this.channels.push({
            name: `Dante Speaker Out`,
            key: `danteSpeakerOut`,
            mute: { address: `RM:NeOut_Fader/Ch/On`, subAddress: [2, 3], invert: true },
            volume: { address: `RM:NeOut_Fader/Ch/Level`, subAddress: [2, 3] },
            filters: { input: true, mics: true, output: true },
        });
        for (let n = 0; n < 2; n++) {
            this.channels.push({
                name: `Analog Mic ${n + 1}`,
                key: `extMic-${n + 1}`,
                mute: { address: `RM:ExtMic_Fader/Ch/On`, subAddress: [n], invert: true },
                volume: { address: `RM:ExtMic_Fader/Ch/Level`, subAddress: [n] },
                filters: { input: true, mics: true, output: true },
            });
        }
        this.channels.push({
            name: `System Microphones (All)`,
            key: `systemMics`,
            mute: { address: `RM:MicMute/All`, subAddress: [0] },
            filters: { input: true, mics: true, output: true },
        });
        // Group numbering starts at 1.
        for (let n = 1; n < 9; n++) {
            this.channels.push({
                name: `System Microphones (Group ${n})`,
                key: `systemMicsGroup-${n}`,
                mute: { address: `RM:MicMute/Group`, subAddress: [n] },
                filters: { input: true, mics: true, output: true },
            });
        }
        this.channels.push({
            name: `SIP 1`,
            key: `sip-1`,
            telephony: {
                lineName: `sip1`,
                receiveGain: { address: `RM:FeIn_Fader/Ch/Level`, subAddress: [4] },
            },
        });
        // v2.0 Yamaha firmware support two SIP lines
        this.channels.push({
            name: `SIP 2`,
            key: `sip-2`,
            telephony: {
                lineName: `sip2`,
                receiveGain: { address: `RM:FeIn_Fader/Ch/Level`, subAddress: [5] },
            },
        });
        // Mix bus support for Dante mic, aux-in to aux out and speaker out.
        this.channels.push({
            name: `MixBus: Dante Input 1 to Speaker Out`,
            key: `di1ToSpeaker`,
            mute: {
                address: `RM:MixBus/Input/Output/On`,
                subAddress: [10],
                output: 8,
                invert: true,
            },
            volume: { address: `RM:MixBus/Input/Output/Level`, subAddress: [10], output: 8 },
            filters: { input: true, mics: true, output: true },
        });
        this.channels.push({
            name: `MixBus: Dante Input 1 to Aux Out`,
            key: `di1ToAuxOut`,
            mute: {
                address: `RM:MixBus/Input/Output/On`,
                subAddress: [10],
                output: 2,
                invert: true,
            },
            volume: { address: `RM:MixBus/Input/Output/Level`, subAddress: [10], output: 2 },
            filters: { input: true, mics: true, output: true },
        });
        for (let n = 0; n < 2; n++) {
            this.channels.push({
                name: `MixBus: Analog Mic ${n + 1} to Speaker Out`,
                key: `am${n + 1}ToSpeaker`,
                mute: {
                    address: `RM:MixBus/Input/Output/On`,
                    subAddress: [8 + n],
                    output: 8,
                    invert: true,
                },
                volume: { address: `RM:MixBus/Input/Output/Level`, subAddress: [8 + n], output: 8 },
                filters: { input: true, mics: true, output: true },
            });
            this.channels.push({
                name: `MixBus: Analog Mic ${n + 1} to Aux Out`,
                key: `am${n + 1}ToAuxOut`,
                mute: {
                    address: `RM:MixBus/Input/Output/On`,
                    subAddress: [8 + n],
                    output: 2,
                    invert: true,
                },
                volume: { address: `RM:MixBus/Input/Output/Level`, subAddress: [8 + n], output: 2 },
                filters: { input: true, mics: true, output: true },
            });
        }
        this.channels.push({
            name: `MixBus: Aux In to Speaker Out`,
            key: `auxInToSpeaker`,
            mute: {
                address: `RM:MixBus/Input/Output/On`,
                subAddress: [2, 3],
                output: 8,
                invert: true,
            },
            volume: { address: `RM:MixBus/Input/Output/Level`, subAddress: [2, 3], output: 8 },
            filters: { input: true, mics: true, output: true },
        });
    }
    // phase callbacks
    onConfigure(config) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            for (const ch of this.channels) {
                (_a = ch.mute) === null || _a === void 0 ? true : delete _a.configured;
                (_b = ch.telephony) === null || _b === void 0 ? true : delete _b.configured;
                (_c = ch.volume) === null || _c === void 0 ? true : delete _c.configured;
            }
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield this.socket.send('devstatus runmode', /^OK\s+devstatus\s+runmode\s+(\S+)/i, ['initialize']);
            if (match[1].toLowerCase() !== '"normal"')
                return 'verifyFailed';
            yield this.socket.send('scpmode valuetype raw', // send raw (non-normalized) values
            /^OK\s+scpmode\s+valuetype/i, ['initialize']);
            yield this.socket.send('identify 5', // flash LEDs for 5 seconds
            /^OK\s+identify\s+5/i, ['initialize']);
            return 'connected';
        });
    }
    // other class methods
    getAvailableTelephonyChannel(callType) {
        return this.channels.find(ch => {
            var _a, _b;
            return callType === 'voip' &&
                ch.telephony !== undefined &&
                ((_b = (_a = this.state.calls.values[ch.key]) === null || _a === void 0 ? void 0 : _a.callState) !== null && _b !== void 0 ? _b : 'disconnected') === 'disconnected';
        });
    }
    makeParamCommand(type, param, value) {
        // Assume stereo parameters are ganged in the Adecia software so we only need to set one
        // value of a stereo pair.
        var _a;
        const tokens = [
            type,
            param.address,
            param.subAddress[0].toString(),
            `${(_a = param.output) !== null && _a !== void 0 ? _a : 0}`,
        ];
        if (value !== undefined)
            tokens.push(value);
        return tokens.join(' ');
    }
    matchParamResponse(resp, op, type, param) {
        var _a;
        if (param === undefined)
            return undefined;
        const tokens = Array.isArray(resp) ? resp : resp.split(/\s+/);
        if (tokens.length >= 1 && tokens[0].toLowerCase() === 'error')
            return '';
        // Assume stereo parameters are ganged in the Adecia software so we only need to check one
        // value of a stereo pair.
        if (tokens.length >= 6 &&
            tokens[0].toLowerCase() === op.toLowerCase() &&
            tokens[1].toLowerCase() === type.toLowerCase() &&
            tokens[2].toLowerCase() === param.address.toLowerCase() &&
            tokens[3] === param.subAddress[0].toString() &&
            tokens[4] === `${(_a = param.output) !== null && _a !== void 0 ? _a : 0}`) {
            return tokens[5];
        }
        return undefined;
    }
    testFilter(ch, name) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        switch (name) {
            case 'amplifier':
            case 'assistiveListeningVolume':
            case 'overflowRoomVolume':
            case 'soundReinforcementVolume':
                return ch.volume !== undefined && ((_b = (_a = ch.filters) === null || _a === void 0 ? void 0 : _a.output) !== null && _b !== void 0 ? _b : false);
            case 'assistiveListeningMute':
            case 'assistiveListeningMuteStatus':
            case 'overflowRoomMute':
            case 'overflowRoomMuteStatus':
            case 'soundReinforcementMute':
            case 'soundReinforcementMuteStatus':
                return ch.mute !== undefined && ((_d = (_c = ch.filters) === null || _c === void 0 ? void 0 : _c.output) !== null && _d !== void 0 ? _d : false);
            case 'audioInputMute':
            case 'audioInputMuteStatus':
            case 'mics':
            case 'micsMuteStatus':
                return ch.mute !== undefined && ((_f = (_e = ch.filters) === null || _e === void 0 ? void 0 : _e.input) !== null && _f !== void 0 ? _f : false);
            case 'audioInputVolume':
                return ch.volume !== undefined && ((_h = (_g = ch.filters) === null || _g === void 0 ? void 0 : _g.input) !== null && _h !== void 0 ? _h : false);
            case 'preset':
                return false;
            case 'receiveGain':
                return false;
            case 'telephony':
                return ch.telephony !== undefined;
            default:
                break;
        }
        this.log.error(`unhandled DspDetectedFilter ${name}`);
        return false;
    }
    validate(config, info) {
        return __awaiter(this, void 0, void 0, function* () {
            const ch = this.channels.find(ch => ch.key === config);
            if (ch !== undefined) {
                if (!this.testFilter(ch, info.filter))
                    return 'incompatible';
                const param = ch === null || ch === void 0 ? void 0 : ch[info.type];
                if (param !== undefined) {
                    param.configured = true;
                    return 'ok';
                }
            }
            return 'missing';
        });
    }
}
// static properties
YamahaAdecia.channelsConfigName = 'adeciaControlChannels';
YamahaAdecia.driverType = 'socketDriver';
YamahaAdecia.key = '-MvixGLx05IB7Em65_Eb';
YamahaAdecia.socketOptions = [
    { sendTerminator: '\n', port: 49280 },
];
